import debug from 'debug';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import store from './store';

const logger = debug('c3:launcher:auth');

if (process.env.NODE_ENV === 'development') {
  localStorage.setItem('debug', 'c3:launcher:*');
  logger(`Running on ${process.env.NODE_ENV} mode`);
}

ReactDOM.render(
  <BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);
